<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="滞销等级配置" name="unsalableLevel" >
        </el-tab-pane>
        <el-tab-pane label="影响因子配置" name="impactFactors" >
        </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import unsalableLevel from "../unsalableLevel/unsalableLevel";
import impactFactors from "../impactFactors/impactFactors";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  components: { unsalableLevel, impactFactors },
  mixins: [pagePathMixin],
  data() {
    return {
      activeName: "unsalableLevel",
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
